import { Box } from '@coolblue-development/freddy';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
export const StyledColorPickerItem = styled(Box, { shouldForwardProp: prop => isPropValid(prop) }) `
  position: relative;

  ${({ isLastVisible }) => isLastVisible &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 4px;
      cursor: pointer;
    }
  `}
`;
export const OverlayText = styled(Box) `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme }) => theme.color.font.inverseBase};
  font-weight: ${({ theme }) => theme.typography.h2.fontWeight};
  font-size: ${({ theme }) => theme.typography.fontSize['3xl']};
  z-index: 2;
  cursor: pointer;
`;
//# sourceMappingURL=ColorPicker.styles.js.map